import React, { useEffect } from 'react';

import { Routes, Route, Navigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import MainLayout from '../layouts/MainLayout';
import Home from '../pages/Home/Home';
import BlockDetails from '../pages/BlockDetails/BlockDetails';
import TransactionDetails from '../pages/TransactionDetails/TransactionDetails';
import Accounts from '../pages/Accounts/Accounts';
import Transactions from '../pages/Transactions/Transactions';
import Blocks from '../pages/Blocks/Blocks';
import BlockTransactions from '../pages/BlockTransactions/BlockTransactions';

const Index = () => {
  const disptach = useDispatch();

  const handleFetchBlocks = () => {
    disptach.blocks.handleGetAllBlocks();
  };

  useEffect(() => {
    handleFetchBlocks();
    const interval = setInterval(() => {
      handleFetchBlocks();
    }, 10000);

    return () => clearInterval(interval);
    // eslint-disable-next-line
  }, []);
  return (
    <Routes>
      <Route path='' element={<MainLayout />}>
        <Route path='' index element={<Home />} />
        <Route path='/block/:id' element={<BlockDetails />} />
        <Route path='/transactions/:id' element={<TransactionDetails />} />
        <Route path='/accounts/:id' element={<Accounts />} />
        <Route path='transactions' element={<Transactions />} />
        <Route path='blocks' element={<Blocks />} />
        <Route path='block/:id/transactions' element={<BlockTransactions />} />
        <Route path='*' element={<Navigate to='/' replace />} />
      </Route>
    </Routes>
  );
};

export default Index;
